import { useRepositorySuspenseQuery } from '@mews-commander/data-access';
import { useCurrentEnterpriseId } from '@mews-commander/core';

export const useGetPaymentsConfiguration = () =>
    useRepositorySuspenseQuery('generalConfiguration', 'getAll', {
        enterpriseId: useCurrentEnterpriseId(),
    });
